import { SubmitEvent } from "react";

import { Trans, useTranslation } from "react-i18next";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import { SendOtpCodeToEnable } from "components/Navbar/Controls/Settings/SecurityAndAccount/Security/TwoFactorAuthentication/EnableTwoFactorAuthentication/content/SendOtpCodeToEnable";
import {
    GOOGLE_AUTHENTICATOR,
    MICROSOFT_AUTHENTICATOR
} from "shared/constants/externalLinks";
import { ENABLE_AUTHENTICATION_STEPS } from "shared/types/enums";

import { BorderFrame, Buttons, InnerBottom, InnerTop } from "../components";
import { SendOtpCodeProps } from "../types";

const SendOtpCode = ({
    secretKey,
    isLoading,
    error,
    otpCode,
    authType,
    setOtpCode,
    changeOtpCode,
    changeStep,
    sendOtpCodeSubmit,
    setError
}: SendOtpCodeProps) => {
    const { t } = useTranslation();

    const handleSecondaryButtonClick = () => {
        changeStep(ENABLE_AUTHENTICATION_STEPS.SelectMethod);
        setOtpCode("");
        setError(null);
    };

    const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
        e.preventDefault();
        sendOtpCodeSubmit();
    };

    return (
        <form onSubmit={handleSubmit}>
            <BorderFrame>
                <InnerTop
                    title={
                        <Trans
                            i18nKey="Security##2FA##send otp code##title"
                            components={{
                                1: (
                                    <TextLink
                                        size={TEXT_LINK_SIZES.Normal}
                                        href={MICROSOFT_AUTHENTICATOR}
                                        target="_blank"
                                    >
                                        Microsoft Authenticator
                                    </TextLink>
                                ),
                                2: (
                                    <TextLink
                                        size={TEXT_LINK_SIZES.Normal}
                                        href={GOOGLE_AUTHENTICATOR}
                                        target="_blank"
                                    >
                                        Google Authenticator
                                    </TextLink>
                                )
                            }}
                        />
                    }
                />

                <InnerBottom>
                    <SendOtpCodeToEnable
                        secretKey={secretKey}
                        error={error}
                        isLoading={isLoading}
                        changeCode={changeOtpCode}
                    />
                </InnerBottom>
            </BorderFrame>

            <Buttons
                isLoadingPrimary={isLoading}
                isPrimaryBtnDisabled={otpCode.length < 6 || authType === null}
                primaryBtnTitle={t("Button##verify")}
                secondaryBtnTitle={t("Button##back")}
                onSecondaryBtnClick={handleSecondaryButtonClick}
            />
        </form>
    );
};

export { SendOtpCode };
